import React from "react";
import Layout from "../components/organisms/Layout";
import DynamicComponent from "../components/molecules/DynamicComponent";

import Storyblok, { useStoryblok } from "../utils/storyblok";

export default function PaymentMethods({ story, preview, children }) {
    const enableBridge = true; // load the storyblok bridge everywhere
    // use the preview variable to enable the bridge only in preview mode
    // const enableBridge = preview;
    story = useStoryblok(story, enableBridge);

    return (
        <>
            <Layout >
                <DynamicComponent blok={story.content} />
            </Layout>
        </>
    );
}

export async function getStaticProps({ params, preview = false }) {
    let slug = "/payment-methods";
    let sbParams = {
        version: "draft", // or 'draft'
    };

    if (preview) {
        sbParams.version = "draft";
        sbParams.cv = Date.now();
    }

    let { data } = await Storyblok.get(`cdn/stories/${slug}`, sbParams);

    return {
        props: {
            story: data ? data.story : false,
            preview,
        },
        revalidate: 10, // revalidate every hour
    };
}
